import Loadable from '@loadable/component'
// TinySlider is client-side only

const HeroSlider = Loadable(() => import('./HeroSliderInner'))

export default HeroSlider
